export const ORDERBOOK_INIT = 'ORDERBOOK_INIT';
export const OPEN_FUTURES_ORDER_LIST = 'OPEN_FUTURES_ORDER_LIST';
export const OPEN_ORDER_LIST = 'OPEN_ORDER_LIST';
export const ORDER_STORE = 'ORDER_STORE';
export const ORDER_UPDATE = 'ORDER_UPDATE';
export const ORDER_CANCEL = 'ORDER_CANCEL';
export const ORDER_PUSH_MY_ORDER = 'ORDER_PUSH_MY_ORDER';
